export const REQUIRED_PHOTOS_AMOUNT = 15;
export const MAX_PHOTOS_AMOUNT = 50;
